var React = require('react');

function GullInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.66156,1.16291C7.25224-.91332,5.15823,1.47184,5.44246,2.703h0l-.00931-.03693C5.09975,1.44778,2.209.27963.07646,3.60668A3.73023,3.73023,0,0,1,6.08874,5.50512h0l.01491.06175a3.72933,3.72933,0,0,1,4.55791-4.40393Z","fill":"#e21d6c","fillRule":"evenodd"}));
}

GullInline.defaultProps = {"width":"11","height":"6","viewBox":"0 0 11 6"};

module.exports = GullInline;

GullInline.default = GullInline;
